import React, { useState } from 'react'

import axios from 'axios'

let NotificationsWidget

// Lazy-loads the notifications popover widget on first interaction and builds the
// popover node. Opening the popover marks the feed as read (PUT check-notifications)
// and zeroes the badge locally. Mirrors useCartWidget / useMessagesWidget.
function useNotificationsWidget({ notifications }) {
  const [isWidgetLoaded, setIsWidgetLoaded] = useState(false)
  const [isRead, setIsRead] = useState(false)

  function loadWidget(callback) {
    if (NotificationsWidget) {
      callback?.()
      return
    }

    import('Pods/LazyLoaded/NotificationsWidget/NotificationsWidget')
      .then((module) => {
        NotificationsWidget = module.default
        setIsWidgetLoaded(true)
        callback?.()
      })
      .catch((error) => {
        console.error('Failed to load NotificationsWidget:', error)
      })
  }

  function markAllAsRead() {
    axios
      .put('/api/internal/users/check-notifications')
      .then(() => setIsRead(true))
      .catch()
  }

  const isLoaded = isWidgetLoaded && !!NotificationsWidget
  const unreadCount = isRead ? 0 : notifications.feedSize

  const popoverComponent = isLoaded ? (
    <NotificationsWidget notifications={notifications.data} isMaintenance={notifications.isFeedMaintenance} />
  ) : null

  return {
    isLoaded,
    loadWidget,
    popoverComponent,
    markAllAsRead,
    unreadCount,
  }
}

export { useNotificationsWidget }
